import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { LicenseInfo } from '@mui/x-license';
import reportWebVitals from './reportWebVitals';
import { openPanel } from './openpanel';
import { FeatureFlagProvider } from './ContextApi/FeatureFlagContext';

const muiXLicenseKey = process.env.REACT_APP_MUI_X_LICENSE_KEY;
if (muiXLicenseKey) {
  LicenseInfo.setLicenseKey(muiXLicenseKey);
}

openPanel.init();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
const options = {
  api_host: process.env.REACT_APP_PUBLIC_POSTHOG_HOST,
}

root.render(
  // <React.StrictMode>
  // <PostHogProvider
  //   apiKey={process.env.REACT_APP_PUBLIC_POSTHOG_KEY}
  //   options={options}
  // >
    <FeatureFlagProvider>
      <App />
    </FeatureFlagProvider>
  // </PostHogProvider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
